module.exports = __webpack_public_path__ + "img/wild_wolf_256.a5df49e5.png";